import { render, staticRenderFns } from "./QuestionAnswerInput.vue?vue&type=template&id=6abc94e1&scoped=true"
import script from "./QuestionAnswerInput.vue?vue&type=script&lang=js"
export * from "./QuestionAnswerInput.vue?vue&type=script&lang=js"
import style0 from "./QuestionAnswerInput.vue?vue&type=style&index=0&id=6abc94e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abc94e1",
  null
  
)

export default component.exports